module.exports = __webpack_public_path__ + "img/logo-gestev-fr.ff48362b.svg";